<template>
  <div></div>
</template>

<script>
export default {
  name: "PostCompleteOrderModals",
  data() {
    return {};
  },
  mounted() {
    //alert("TODO: PostCompleteOrderModals.vue");
  },
  methods: {}
};
</script>

<style>
</style>